/**
 * Palantir PMS - Software para la gestión de la industria hotelera
 * Palantir PMS - Software for hotel industry management
 * Autor / Author: Alberto Castro Ull
 * Fecha de creación / Created on: 31/07/2025
 * Todos los derechos reservados / All rights reserved.
 * Este software es propiedad de Alberto Castro Ull.
 * This software is the property of Alberto Castro Ull.
 * Su uso está restringido a clientes con licencia emitida por Markulia Group, S.L.
 * Use is restricted to clients licensed by Markulia Group, S.L.
 */

import { useEffect } from "react";
import axios from "../api/axiosInstance";

export const useReservationInitializer = ({ navigate, businessUnitId, setIsRecoveringReservation, setFormData, setIsReadyToRender }) => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const businessUnitId = params.get("business_unit_id");

    if (!businessUnitId) {
      alert("No business_unit_id provided in URL");
      return;
    }

    const createGroupWithFirstReservation = async () => {
      console.log("🚀 Creando reservation_group + primera reserva Draft");

      try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/reservation-groups/create`, {
          number_of_rooms: 1,
          created_by: "Admin",
          business_unit_id: Number(businessUnitId),
        });

        const { group_id, group_locator, reservation_ids } = response.data;
        const firstReservationId = reservation_ids[0];

        console.log("✅ Grupo creado:", {
          group_id,
          group_locator,
          reservation_id: firstReservationId,
        });

        navigate(`/new-reservation/${firstReservationId}?business_unit_id=${businessUnitId}`);
      } catch (error) {
        console.error("❌ Error creando grupo de reservas:", error);
        alert("Error creating group and first reservation");
      }
    };

    const pathMatch = window.location.pathname.match(/\/new-reservation\/(\d+)/);
    const urlHasCustomerButNoId =
      window.location.pathname.includes("/new-reservation") &&
      !pathMatch &&
      window.location.search.includes("customer_id");

    // 🚫 Si la URL ya tiene un ID → NO crear nada.
    if (pathMatch) {
      console.log("⛔ Ya hay reservation_id en la URL → no crear nueva");
      return;
    }

    // 🚫 Si viene customer_id sin id → no crear
    if (urlHasCustomerButNoId) {
      console.log("⛔ Hay customer_id pero no id → no crear");
      return;
    }

    // ✅ Crear solo si es /new-reservation “vacío”
    createGroupWithFirstReservation();

  }, [navigate]);





    useEffect(() => {
    const pathMatch = window.location.pathname.match(/\/new-reservation\/(\d+)/);
    const reservationId = pathMatch ? pathMatch[1] : null;

    if (!reservationId) return;

    setIsRecoveringReservation(true);

    axios.get(`${process.env.REACT_APP_API_URL}/api/reservation-drafts/${reservationId}`)
      .then((res) => {
        console.log("✅ Reserva encontrada al cargar:", res.data);
        setIsRecoveringReservation(false);
      })
      .catch(async (err) => {
        console.warn("⛔ Error al buscar reserva original:", err);

        if (err.response?.status === 404) {
          console.warn("⚠️ Reserva no encontrada tras refresh. Creando nueva Draft...");

          try {
            // 👉 ahora creamos un DRAFT real
            const res = await axios.post(
              `${process.env.REACT_APP_API_URL}/api/reservation-drafts`,
              {
                created_by: "AutoRecover",
                business_unit_id: Number(businessUnitId)
              }
            );

            const newId = res.data.id;

            // 👉 si tu endpoint de drafts no usa check-in/check-out, quita este bloque sin miedo
            const settingsRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/hotel-settings`, {
              params: { business_unit_id: businessUnitId }
            });

            await axios.patch(`${process.env.REACT_APP_API_URL}/api/reservation-drafts/${newId}`, {
              check_in_time: settingsRes.data.checkin_time,
              check_out_time: settingsRes.data.checkout_time,
              updated_by: "AutoInit"
            });


            console.log("🔁 Redirigiendo a nuevo reservation-draft tras pérdida");
            window.location.href = `/new-reservation/${newId}?business_unit_id=${businessUnitId}`;
          } catch (creationError) {
            console.error("❌ Error creando reservation-draft tras pérdida:", creationError);
          }
        }
        else {
          setIsRecoveringReservation(false);
        }
      });
  }, []);


  useEffect(() => {
      const pathMatch = window.location.pathname.match(/\/new-reservation\/(\d+)/);
      const reservationId = pathMatch ? pathMatch[1] : null;
    
      if (!reservationId) return;
    
      const fetchReservationData = async () => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/reservation-drafts/${reservationId}`)
;
          const data = response.data;
          console.log("🔍 [PRUEBA CLAVE] DATA DEL BACKEND:", JSON.stringify(data, null, 2));

  
          console.log("🧾 [Backend] Datos recibidos → check_in_date:", data.check_in_date);
    
          const updatedFormData = {
            check_in_date: data.check_in_date || "",
            check_in_time: data.check_in_time || "",
            check_out_date: data.check_out_date || "",
            check_out_time: data.check_out_time || "",
            arrival_date: data.arrival_date || "",
            arrival_time: data.arrival_time || "",
            departure_date: data.departure_date || "",
            departure_time: data.departure_time || "",
            room_category_id: data.room_category_id || "",
            room_id: data.room_id || "",
            rate_id: data.rate_id || "",
            group_rate_id: data.group_rate_id || "", 
            room_nights: data.room_nights || "",
            adults: data.adults || "",
            children: data.children || "",
            children_ages: (data.children_ages || []).join(","),
            babies: data.babies || 0,
            special_requests: data.special_requests || "",
            payment_status: data.payment_status || "Pending",
            total_price: data.total_price || "",
            total_extras: data.total_extras || 0,       // 👈 añadido
            extras: data.extras || [],                  // 👈 añadido
            created_by: data.created_by || "Admin",
            updated_by: data.updated_by || "",
            cancellation_reason: data.cancellation_reason || "",
            status: data.status || "Draft",
            business_unit_id: data.business_unit_id || 1,
          };
    
          // ✅ Corrección automática de room_nights si está vacío pero hay fechas
          if (
            updatedFormData.check_in_date &&
            updatedFormData.check_out_date &&
            (!updatedFormData.room_nights || updatedFormData.room_nights === "")
          ) {
            const checkIn = new Date(updatedFormData.check_in_date);
            const checkOut = new Date(updatedFormData.check_out_date);
            const diff = Math.ceil((checkOut - checkIn) / (1000 * 60 * 60 * 24));
            updatedFormData.room_nights = diff > 0 ? diff : "";
            console.log("🧮 room_nights recalculado tras cargar:", updatedFormData.room_nights);
          }
    
    
          console.log("📦 Datos de reserva cargados desde DB:", updatedFormData);
          setFormData((prev) => ({
            ...prev,
            ...updatedFormData,
            reservation_group_id: data.reservation_group_id || prev.reservation_group_id,
            group_locator: data.group?.group_locator || data.group_locator || prev.group_locator,
            group_total_rooms: data.group?.number_of_rooms || prev.group_total_rooms,
          
          }));
          console.log("🟩 Reservation data fully loaded and UI state is ready.");
          setIsReadyToRender(true);
         
    
        } catch (error) {
          console.error("❌ Error al cargar datos de la reserva:", error);
        }
      };
    
      fetchReservationData();
    }, [window.location.pathname, window.location.search]);


};
